import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function ScrollToTop() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to the top when the route changes
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    // Scroll to the top when the component first mounts
    window.scrollTo(0, 0);
  }, []);

  return null; // This component doesn't render anything
}

export default ScrollToTop;
